<section class="search-wrapper">
  <!-- <div class="search-bar mt-3">
  </div>
  <div class="row search-menu" *ngIf="selectedTags?.length || this.searchesCollection.rb_collections.length">
    <div class="col-12">
      <mat-chip-list #chipList aria-label="Fruit selection">
        <mat-chip *ngFor="let tag of selectedTags">
          {{tag.name}}
          <button type="button" class="close ml-1" aria-label="Close" (click)="selectEvent(tag)">
            <span aria-hidden="true">&times;</span>
          </button>
        </mat-chip>
        <mat-chip color="primary" selected (click)='resetTag()'>
          Reset
        </mat-chip>
      </mat-chip-list>
    </div>
  </div> -->


  <div class="kb-content">
    <div class="row kb-content-info match-height">
      <div class="col-md-4 col-sm-6 kb-content-card cursor" *ngFor="let tag of rows">
        <div class="card" (click)="selectTag(tag)">
          <div class="card-content">
            <div class="card-body text-center p-4">
              <a>
                <h5 class="mt-2">{{tag.title}}</h5>
                <!-- <p class="m-0 text-muted">{{tag.description}}</p> -->
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 kb-no-content" *ngIf="!rows?.length">
        <div class="card bg-transparent shadow-none">
          <div class="card-content">
            <div class="card-body text-center">
              <p class="m-0 d-flex justify-content-center align-items-center">
                <i class="ft-alert-circle font-medium-2 mr-1"></i>
                <span>No result found</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex p-2 justify-content-center  ">
      <ngb-pagination [collectionSize]="count" [pageSize]="pageSize" [(page)]="currentPage" [rotate]="true"
        (pageChange)="pageChange(currentPage)" [boundaryLinks]="true" [ellipses]="true">
      </ngb-pagination>
    </div>
  </div>
</section>